import { render, staticRenderFns } from "./HousingModalQuotasSingle.vue?vue&type=template&id=846fcdbc&scoped=true&"
import script from "./HousingModalQuotasSingle.vue?vue&type=script&lang=js&"
export * from "./HousingModalQuotasSingle.vue?vue&type=script&lang=js&"
import style0 from "./HousingModalQuotasSingle.vue?vue&type=style&index=0&id=846fcdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846fcdbc",
  null
  
)

export default component.exports